export default __webpack_public_path__ + "img/9a673c3091bbb9c9ebc498670dd4e8dd.png";